/** @jsxImportSource @emotion/react */
"use client";
import type { Interpolation } from "@emotion/react";
import { useId } from "react";

import { animations } from "../../../../../global/emotion/animations";

const baseStyle: Interpolation = {
  display: "flex",
  justifyContent: "center",
};
const animationStyle: Interpolation = {
  animationDuration: "0.5s",
  animationIterationCount: "infinite",
  animationName: animations.rotate,
  animationTimingFunction: "linear",
};

type LoaderProps = {
  color?: string;
  size?: number;
};

export const Loader = ({ color = "#6D0EC1", size = 50 }: LoaderProps) => {
  const gradientId = useId();
  return (
    <div css={baseStyle}>
      <svg
        width={size}
        height={size}
        viewBox="0 0 50 50"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        css={animationStyle}
      >
        <defs>
          <linearGradient id={gradientId} x1="0" x2="1" y1="0" y2="0">
            <stop offset="0%" stopColor={color} stopOpacity="0" />
            <stop offset="100%" stopColor={color} stopOpacity="1" />
          </linearGradient>
        </defs>
        <path
          d="M7 23A18 18 0 0 1 43 27"
          strokeWidth="7"
          stroke={`url(#${gradientId})`}
          strokeLinecap="round"
        />
      </svg>
    </div>
  );
};
